import React from "react";
import { Container, Grid, Typography } from "@material-ui/core";
import { PostData } from "../../api/service";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

const NAVY = "#1A2B4A";
const GOLD = "#C8991A";
const INK = "#374151";
const MUTED = "#6b7280";
const BORDER = "#e8e0d0";

const PLACEHOLDER = "/images/icons/iqac-icon.png";

// strips the rich-text markup so the card can show a short teaser
const excerpt = (html, length) => {
  if (!html) return "";
  let text = html
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
  return text.length > length ? text.slice(0, length) + " . . ." : text;
};

const IMAGE_EXT = ["jpg", "jpeg", "png"];

const isImage = (f) =>
  !!f &&
  !!f.url &&
  (f.fileType === "image" ||
    IMAGE_EXT.includes(String(f.ext || "").toLowerCase()));

// the API falls back to the first attachment when no photo was uploaded, so a
// PDF can arrive here - only use it when it is really an image
export const clubPhoto = (el) =>
  el && Array.isArray(el.featured_photo) && isImage(el.featured_photo[0])
    ? el.featured_photo[0].url
    : null;

const photoOf = (el) => clubPhoto(el) || PLACEHOLDER;

export const ClubList = (props) => {
  const [data, setData] = React.useState([]);
  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    let d = {
      dept_code: "RANGIA",
      type: "STUDENT_CLUBS",
    };

    PostData(`/getnoticesbytypedept`, d).then((resp) => {
      setData(Array.isArray(resp) ? resp : []);
      setIsLoaded(true);
    });
  }, []);

  const open = (el) => {
    props.history.push(`/students/clubs/${el.id}`);
  };

  return (
    <div>
      <BreadCrumbOwn title="Student Clubs" />

      <Container className="mb-5">
        <Typography
          variant="h5"
          style={{ margin: "1em 0", fontWeight: 700 }}
          gutterBottom
        >
          Student Clubs
        </Typography>

        {!isLoaded && <Typography>Loading . . . </Typography>}

        {isLoaded && data.length === 0 && (
          <Typography>No Student Clubs</Typography>
        )}

        <Grid container spacing={3}>
          {data.map((el, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <div
                className="club-card"
                role="button"
                tabIndex={0}
                onClick={() => open(el)}
                onKeyPress={() => open(el)}
              >
                <div className="club-card__media">
                  <img alt={el.title} src={photoOf(el)} />
                </div>
                <div className="club-card__body">
                  <div className="club-card__title">{el.title}</div>
                  <div className="club-card__text">
                    {excerpt(el.description, 120)}
                  </div>
                  <div className="club-card__more">Read More &rsaquo;</div>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>

      <style>{`
        .club-card {
          height: 100%;
          display: flex;
          flex-direction: column;
          background: #fff;
          border: 1px solid ${BORDER};
          border-radius: 10px;
          overflow: hidden;
          cursor: pointer;
          transition: box-shadow 0.18s ease, transform 0.18s ease;
          font-family: 'Lato', sans-serif;
        }
        .club-card:hover {
          box-shadow: 0 8px 24px rgba(26,43,74,0.12);
          transform: translateY(-2px);
        }
        .club-card__media {
          height: 170px;
          background: #f7f6f2;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          border-bottom: 3px solid ${GOLD};
        }
        .club-card__media img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .club-card__body {
          padding: 14px 16px 16px;
          display: flex;
          flex-direction: column;
          gap: 6px;
          flex: 1;
        }
        .club-card__title {
          font-size: 16px;
          font-weight: 700;
          color: ${NAVY};
          line-height: 1.3;
        }
        .club-card__text {
          font-size: 13px;
          color: ${MUTED};
          line-height: 1.5;
          flex: 1;
        }
        .club-card__more {
          font-size: 12.5px;
          font-weight: 700;
          color: ${GOLD};
          letter-spacing: 0.4px;
        }
      `}</style>
    </div>
  );
};

export class ClubSingle extends React.Component {
  state = {
    data: null,
    isLoaded: false,
  };

  componentDidMount() {
    this.__load(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.__load(this.props.match.params.id);
    }
  }

  __load = (id) => {
    this.setState({ isLoaded: false });

    PostData(`/getsingleeventbyid`, { eventId: id }).then((resp) => {
      // the endpoint answers with a single object, or false when nothing matches
      let d = Array.isArray(resp) ? resp[0] : resp;

      this.setState({
        data: d && d.id ? d : null,
        isLoaded: true,
      });
    });
  };

  render() {
    let { data, isLoaded } = this.state;

    return (
      <div>
        <BreadCrumbOwn title={data && data.title ? data.title : "Student Club"} />

        <Container className="mb-5" style={{ minHeight: "60vh" }}>
          <div style={{ margin: "1.5em 0" }}>
            <a
              style={{ color: GOLD, fontWeight: 700, cursor: "pointer" }}
              onClick={() => this.props.history.push("/students/clubs")}
            >
              &lsaquo; Back to Student Clubs
            </a>
          </div>

          {!isLoaded && <Typography>Loading . . . </Typography>}

          {isLoaded && !data && <Typography>Club not found</Typography>}

          {isLoaded && data && (
            <div style={{ fontFamily: "'Lato', sans-serif", color: INK }}>
              <Typography
                variant="h5"
                style={{ fontWeight: 700, marginBottom: 6 }}
                gutterBottom
              >
                {data.title}
              </Typography>

              {clubPhoto(data) && (
                  <div style={{ margin: "1.5em 0" }}>
                    <img
                      alt={data.title}
                      src={clubPhoto(data)}
                      style={{
                        maxWidth: "100%",
                        borderRadius: 10,
                        border: `1px solid ${BORDER}`,
                      }}
                    />
                  </div>
                )}

              <div
                style={{ marginTop: "1.5em", textAlign: "justify" }}
                dangerouslySetInnerHTML={{ __html: data.description }}
              ></div>

              {Array.isArray(data.upload_info) &&
                data.upload_info.length > 0 && (
                  <div style={{ marginTop: "2em" }}>
                    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                      Documents
                    </Typography>
                    <ul>
                      {data.upload_info.map((el, index) => (
                        <li key={index}>
                          <a target="_blank" rel="noreferrer" href={el.url}>
                            View {index + 1}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

export default ClubList;
